import React from 'react';
import { observer, inject } from 'mobx-react';
import { Grid, withStyles, FormControl, TextField } from '@material-ui/core';
import MUIDataTable from 'mui-datatables';
import PageTitle from '../../components/PageTitle/PageTitle';
import IconButton from '@material-ui/core/IconButton';
// import CustomToolbar from "./CustomToolbar";
import * as Icons from '@material-ui/icons';
import { Button } from '@material-ui/core';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import Loader from '../../components/Loader/LoaderView';
import Swal from 'sweetalert2';
import { withTranslation } from 'react-i18next';
import { clearLocalStorage } from '../../utils/common';
import CustomFooter from '../../components/Table/CustomFooter';

const noImageUrl = 'https://airpresense.s3-ap-southeast-1.amazonaws.com/images/no_img_gray.png';
class DeviceTypeManager extends React.Component {
  async componentDidMount() {
    const { offset, limit, search, sort, order, action } = this.props.deviceType.toJS();
    if (action) {
      await this.props.deviceType.getDeviceTypeList(offset, limit, search, sort, order);
      this.props.deviceType.setAction('action', null);
    } else {
      this.props.deviceType.resetData();
      await this.props.deviceType.getDeviceTypeList();
    }
  }

  deleteItem(id) {
    const { t } = this.props;
    Swal.fire({
      html: `<span class="swal-icon">
              <i
                class="fa fa-trash-o fa-3x fa-border"
                style="border: solid .08em #f27474; border-radius: 1.1em; margin-bottom: 35px; margin-top: 22px;">
              </i>
            </span>
            <br/>
            <h4>${t('delete_device_type')}`,
      showCancelButton: true,
      cancelButtonText: `${t('cancel')}`,
      confirmButtonText: `${t('delete')}`,
      reverseButtons: true,
      customClass: {
        container: 'my-swal',
      },
    }).then(async (result) => {
      if (result.value) {
        try {
          const result = await this.props.deviceType.deleteDeviceType(id);
          if (result.statusCode === 200) {
            Swal.fire({ html: `<h4>${t('delete_success')}`, type: 'success' }).then(async (resultSuccess) => {
              if (resultSuccess.value) {
                await this.props.deviceType.getDeviceTypeList();
              }
            });
          } else {
            Swal.fire({ html: `<h4>${t('failed_to_delete')}`, type: 'error' });
          }
        } catch (e) {
          if (e.statusCode === 401) {
            clearLocalStorage();
            window.location.href = '/login';
          } else {
            Swal.fire({ html: `<h4>${t('failed_to_delete')}`, type: 'error' });
          }
        }

        //   const result = await this.props.deviceType.deleteDeviceType(id);
        //   if (result) {
        //     await this.props.deviceType.getDeviceTypeList();
        //     Swal.fire({html:"<h4>Successfully Deleted! <br/>The device type has been deleted.", type: "success"});
        //   } else {
        //     Swal.fire({html: "<h4>Failed to delete <br/>This device type has not been delete.", type: "error"});
        //   }
        // } else if (result.dismiss === Swal.DismissReason.cancel) {
        //   Swal.fire({html:"<h4>Cancelled <br/>This device type has not been delete. :)",type: "error"});
      }
    });
  }

  createDeviceType() {
    const { classes, t } = this.props;
    return (
      <Button
        variant='outlined'
        color='primary'
        onClick={() => this.props.history.push('devicetype/create')}
        className={classes.button}
      >
        <Icons.Add />
        {t('create_device_type')}
      </Button>
    );
  }

  titleContent() {
    const { classes, t } = this.props;
    const { search } = this.props.deviceType.toJS();
    return (
      <div className={classes.titleBar}>
        <Grid className={classes.search}>
          <FormControl variant='outlined' className={classes.formControl} fullWidth>
            <TextField
              variant='outlined'
              size='small'
              value={search || ''}
              name='search'
              id='search'
              className={classes.contentInput}
              placeholder={t('search')}
              onChange={(e) => this.handleChangeSearch(e)}
            ></TextField>
          </FormControl>
        </Grid>
      </div>
    );
  }

  handleChangeSearch = (event) => {
    const { value } = event.target;
    this.props.deviceType.setData('offset', 0, false);
    this.props.deviceType.setData('search', value);
  };

  validateTableRow = (data, expectedSize) => {
    return data && Array.isArray(data) && data.length === expectedSize;
  };

  handleChangeRowsPerPage = (value) => {
    this.props.deviceType.setData('limit', value);
  };

  handlechangePage = (value) => {
    const { limit } = this.props.deviceType.toJS();
    this.props.deviceType.setData('offset', value * limit);
  };

  render() {
    const { classes, t } = this.props;
    const { deviceTypes, loading, limit, search, sort, order } = this.props.deviceType.toJS();
    const page = deviceTypes.data ? deviceTypes.pagination.page - 1 : 0;
    const count = deviceTypes.data ? deviceTypes.pagination.count : 0;
    const ARRAYSIZE = 7;
    const columns = [
      {
        name: 'id',
        label: `${t('id')}`,
        options: {
          filter: true,
          sort: true,
          sortDirection: sort === 'id' && order ? order : 'none',
        },
      },
      {
        name: 'imgUrl',
        label: `${t('photo')}`,
        options: {
          filter: false,
          sort: false,
          customBodyRender: (_value, tableMeta) => {
            const row = tableMeta.rowData;
            const imgUrl = this.validateTableRow(row, ARRAYSIZE) ? row[1] : noImageUrl;
            return (
              <div className={classes.imgPreviewContainer}>
                <div
                  className={classNames(classes.imgPreview, classes.rounded)}
                  style={{
                    background: `url("${imgUrl || noImageUrl}") center no-repeat`,
                  }}
                />
              </div>
            );
          },
        },
      },
      {
        name: 'name',
        label: `${t('name')}`,
        options: {
          filter: true,
          sort: true,
          sortDirection: sort === 'name' && order ? order : 'none',
          customBodyRender: (value, tableMeta, updateValue) => {
            const row = tableMeta.rowData;
            return <div className={classes.columnWidth200}>{this.validateTableRow(row, ARRAYSIZE) && row[2]}</div>;
          },
        },
      },
      {
        name: 'type',
        label: `${t('type')}`,
        options: {
          filter: true,
          sort: true,
          sortDirection: sort === 'type' && order ? order : 'none',
          customBodyRender: (value, tableMeta, updateValue) => {
            const row = tableMeta.rowData;
            return <div className={classes.columnWidth200}>{this.validateTableRow(row, ARRAYSIZE) && row[3]}</div>;
          },
        },
      },
      {
        name: 'manufacturer',
        label: `${t('manufacturer')}`,
        options: {
          filter: true,
          sort: true,
          sortDirection: sort === 'manufacturer' && order ? order : 'none',
          customBodyRender: (value, tableMeta, updateValue) => {
            const row = tableMeta.rowData;
            return <div className={classes.columnWidth200}>{this.validateTableRow(row, ARRAYSIZE) && row[4]}</div>;
          },
        },
      },
      {
        name: 'useDevice',
        options: {
          filter: true,
          sort: true,
          display: false,
        },
      },
      {
        name: '',
        label: `${t('action')}`,
        options: {
          filter: true,
          customBodyRender: (value, tableMeta, updateValue) => {
            const row = tableMeta.rowData;
            // const id = this.validateTableRow(row, ARRAYSIZE) ? row[0] : '';
            return (
              <div className={classes.actionBox}>
                <Link to={`/app/devicetype/${this.validateTableRow(row, ARRAYSIZE) ? row[0] : ''}/view`}>
                  <IconButton title={t('view')}>
                    {' '}
                    <Icons.FormatListBulleted color='primary' />
                  </IconButton>
                </Link>
                <Link
                  to={`/app/devicetype/${this.validateTableRow(row, ARRAYSIZE) ? row[0] : ''}/edit`}
                  title={t('edit')}
                >
                  <IconButton>
                    {' '}
                    <Icons.Edit color='primary' />
                  </IconButton>
                </Link>
                <IconButton
                  title={t('delete')}
                  disabled={row && row[5]}
                  onClick={() => this.deleteItem(row ? row[0] : '')}
                >
                  <Icons.Delete color={row && row[5] ? 'disabled' : 'primary'} />
                </IconButton>
              </div>
            );
          },
        },
      },
    ];
    return (
      <React.Fragment>
        <Loader loading={loading} />
        <PageTitle title={t('all_device_types')} button={this.createDeviceType()}>
          {this.titleContent()}
        </PageTitle>
        <Grid className={classes.mainContain} container spacing={32}>
          <Grid item xs={12}>
            <MUIDataTable
              // title={this.createDeviceType()}
              data={deviceTypes.data}
              columns={columns}
              options={{
                count: deviceTypes.data ? deviceTypes.pagination.count : 0,
                page: deviceTypes.data ? deviceTypes.pagination.page - 1 : 0,
                searchText: search,
                serverSide: true,
                pagination: true,
                onTableChange: (action, tableState) => {
                  // console.log(action, tableState);
                  switch (action) {
                    case 'changePage':
                      this.props.deviceType.setData('offset', tableState.page * tableState.rowsPerPage);
                      // this.props.user.setData('page',tableState.page);
                      break;
                    case 'changeRowsPerPage':
                      this.props.deviceType.setData('limit', tableState.rowsPerPage);
                      break;
                    case 'search':
                      this.props.deviceType.setData('offset', 0, false);
                      this.props.deviceType.setData('search', tableState.searchText);
                      break;
                    case 'sort':
                      const sortList = tableState.announceText.split(' ');
                      this.props.deviceType.setData('offset', 0, false);
                      this.props.deviceType.setData('sort', sortList[4], false);
                      this.props.deviceType.setData('order', sortList[6] === 'descending' ? 'desc' : 'asc');
                      break;
                    default:
                      break;
                  }
                },
                print: false,
                download: false,
                viewColumns: false,
                search: false,
                sortFilterList: true,
                sort: true,
                selectableRows: 'none',
                selectableRowsOnClick: false,
                filter: false,
                filterType: 'dropdown',
                responsive: 'scrollFullHeight',
                rowsPerPageOptions: [10, 15, 50],
                rowsPerPage: limit,
                customFooter: (rowsPerPage, changeRowsPerPage, changePage, textLabels) => {
                  return (
                    <CustomFooter
                      count={count}
                      page={page}
                      rowsPerPage={limit}
                      changeRowsPerPage={this.handleChangeRowsPerPage}
                      changePage={this.handlechangePage}
                      textLabels={textLabels}
                      rowsPerPageOptions={[10, 15, 50]}
                    />
                  );
                },
              }}
            />
          </Grid>
        </Grid>
      </React.Fragment>
    );
  }
}

const styles = (theme) => ({
  mainContain: {
    marginTop: '5px',
    padding: 16,
  },
  button: {
    height: '38px',
    margin: theme.spacing.unit / 2,
  },
  imgPreviewContainer: {
    width: '100%',
    position: 'relative',
  },
  imgPreview: {
    backgroundSize: 'contain !important',
    height: '100px',
    border: '1px solid #ced4da',
  },
  actionBox: {
    minWidth: '150px',
  },
  columnWidth200: {
    maxWidth: '200px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  formControl: {
    '& .MuiInputLabel-shrink': {
      transform: 'translate(14px, 10px) scale(1)',
    },
    margin: theme.spacing.unit / 2,
    width: '100%',
    marginLeft: theme.spacing.unit * 2,
  },
  contentInput: {
    '& fieldset': {
      top: '2px',
    },
    '& input': {
      paddingTop: '17px',
      paddingBottom: '9px',
    },
  },
  titleBar: {
    display: 'flex',
    marginTop: '-5px',
  },
  search: {
    width: '300px',
    [theme.breakpoints.down('sm')]: {
      width: '250px',
    },
  },
});

export const page = inject('deviceType', 'device')(observer(DeviceTypeManager));
export const translation = withTranslation()(page);
export default withStyles(styles, { withTheme: true })(translation);
